export const Services = (props) => {
    return (
        <div id="services" class="service-style2-area" style={{ backgroundImage: "url(img/pattern/service-style1-area-pt.jpg)" }}>

            <div class="container">
                <div class="sec-title text-center">

                    <h2>Our Services</h2>

                </div>
                <div class="row">
                    {/* <!--Start Single Service Style1--> */}
                    <div class="col-xl-4">
                        <div class="single-service-style2">
                            <div class="img-holder">
                                <div class="inner">
                                    <img src="img/services/service-v2-1.jpg" alt="" />
                                </div>
                            </div>
                            <div class="title-holder">
                                <div class="top">
                                    <div class="text">
                                        <h3><a href="#">RO Routine Service</a></h3>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                    {/* <!--End Single Service Style1-->
            <!--Start Single Service Style1--> */}
                    <div class="col-xl-4">
                        <div class="single-service-style2">
                            <div class="img-holder">
                                <div class="inner">
                                    <img src="img/services/service-v2-2.jpg" alt="" />
                                </div>
                            </div>
                            <div class="title-holder">
                                <div class="top">
                                    <div class="text">
                                        <h3><a href="#">R.O Repair</a></h3>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                    {/* <!--End Single Service Style1-->
            <!--Start Single Service Style1--> */}
                    <div class="col-xl-4">
                        <div class="single-service-style2">
                            <div class="img-holder">
                                <div class="inner">
                                    <img src="img/services/service-v2-3.jpg" alt="" />
                                </div>
                            </div>
                            <div class="title-holder">
                                <div class="top">
                                    <div class="text">
                                        <h3><a href="#">R.O Installation</a></h3>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                    {/* <!--End Single Service Style1--> */}


                    <div class="col-xl-4">
                        <div class="single-service-style2">
                            <div class="img-holder">
                                <div class="inner">
                                    <img src="img/services/service-v2-4.jpg" alt="" />
                                </div>
                            </div>
                            <div class="title-holder">
                                <div class="top">
                                    <div class="text">
                                        <h3><a href="#">R.O Re-Installation</a></h3>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>

                    <div class="col-xl-4">
                        <div class="single-service-style2">
                            <div class="img-holder">
                                <div class="inner">
                                    <img src="img/services/service-v2-5.jpg" alt="" />
                                </div>
                            </div>
                            <div class="title-holder">
                                <div class="top">
                                    <div class="text">
                                        <h3><a href="#">R.O AMC</a></h3>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    )
}
